var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('left-menu',{ref:"leftMenu",attrs:{"menu":_vm.menu},on:{"click":_vm.showContents}}),_c('terminal',{ref:"terminal",attrs:{"editorValue":_vm.editorValue,"dark":_vm.$vuetify.theme.dark},on:{"navigate":_vm.navigate,"toggleMenu":_vm.toggleMenu,"onTerminalCount":_vm.onTerminalCount}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }